<div class="row">
    <div class="col-24">
        <div class="bold-font bottom-20">
            Thank You!
        </div>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <div class="bold-font bottom-20">Online Enrollment Confirmation # {{confirmationNumber}}</div>
    </div>
</div>

<div class="row">
    <div class="col-16">
        <p>
            Your client’s enrollment application has been received. Medicare, the federal agency that runs the Medicare

            program, must approve all enrollments. After we receive confirmation of your client’s enrollment from Medicare,

            your client will receive a letter from us along with an ID card and Evidence of Coverage.
        </p>
        <p>
            Once your client is enrolled in our plan, your client can only disenroll (or enroll in a new plan) during certain times of

            the year. Unless your client meets certain special exceptions, such as if your client moves out of the prescription

            plan service area, your client can only disenroll from a Medicare Part D prescription plan from October 15 through

            December 7 each year. If your client has questions about how or when to disenroll, your client should contact our

            support department.
        </p>
        <p>
            If your client has limited income, your client may qualify for extra help to pay for your client’s drugs costs

            (including help paying the prescription drug premium and yearly deductible). For more information about this extra

            help, your client should contact a local Social Security office or call Medicare at
        </p>
        <p class="bold-font bottom-20"><a href="tel:+18006334227" class="tel-no">1-800-MEDICARE (1-800-633-4227).</a> TTY/TDD users should call <a href="tel:+18774862048" class="tel-no">1-877-486-2048</a>. </p>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <a class="link-button link print" routerLink="/enrollment/print" target="_blank">Print a hard copy of the enrollment Form</a>
        <!--<button class="button primary" (click)="printHardCopy()">Print a hard copy of the enrollment Form >></button>-->
    </div>
</div>
<div class="row">
    <div class="col-24">
        <a href="javascript:void(0)" class="link-button link pdf" (click)="SavePdf()">Save PDF of Completed Enrollment Data</a>
        <!--<button class="button secondary" (click)="SavePdf()">Save PDF of Completed Enrollment Data</button>-->
    </div>
</div>
<div class="row">
    <div class="col-24">
        <button class="button primary" (click)="enrollNew()">Enroll another client</button>
    </div>
</div>







